// import _ from 'lodash';

const orderReceipt = {
  subtotal: 0.0,
  discount: 0.0,
  tax: 0.0,
  shippingCost: 0.0,
  total: 0.0,
  list: [],
}
const OrderReceiptReducer = function (state = orderReceipt, action) {
  switch (action.type) {
    case 'UPDATE_ORDER_RECEIPT': {
      return {
        ...state,
        ...action.details,
        list: action.items,
      }
    }
    default: {
      return state
    }
  }
}

export default OrderReceiptReducer
